import * as React from "react";

import SelectField from "../../../components/SelectField";
import Button from "../../../components/Button";
import {FlagDto, OptionFlagMultiUpdateParamActionType} from "../../../services/Client";
import DataAdapterOptionsView from "../DataAdapterOptionsView";
import * as _ from "lodash";

interface IFlagActionSelectionProps {
    value: OptionFlagMultiUpdateParamActionType | undefined;
    t: reactI18Next.TranslationFunction;
    validItems: DataAdapterOptionsView[];
    flags: FlagDto[];
    // actions
    onChange: (value: OptionFlagMultiUpdateParamActionType | undefined) => void;
    OnAddDeleteChange: (value: FlagDto) => void;
    nextAction: () => void;
    updatedFlag: FlagDto[];
    disableNext: boolean;
}

export const renderActionTypeLabel = (value: OptionFlagMultiUpdateParamActionType | undefined, t: reactI18Next.TranslationFunction) => {
    switch (value) {
        case OptionFlagMultiUpdateParamActionType.ADD:
            return t("PSL_FLAG_MULTI:ADD_ACTION");
        case OptionFlagMultiUpdateParamActionType.REMOVE:
            return t("PSL_FLAG_MULTI:REMOVE_ACTION");
        default:
            return '';
    }
};
export const renderFlagLabel = (value: FlagDto | undefined, t: reactI18Next.TranslationFunction) => {
    if (value) {
        return value.textLabel;
    }
    return '';
};
/** Return the FlagDto references from the roles array that match values. */
export const selectFlags = (roles: FlagDto[], values: FlagDto[]): FlagDto[] => (
    roles.filter(role => _.find(values, value => value.objectId === role.objectId) !== undefined)
);
const getFlatArray = (items: DataAdapterOptionsView[]) => {
    const allAssginedFlags = items.map(item => item.flags);
    return allAssginedFlags.reduce((r: any, e: any) => (r.push(...e), r), []);
};
export const FlagActionSelection: React.StatelessComponent<IFlagActionSelectionProps> = (props: IFlagActionSelectionProps) => {

    let dataSource;
    if (props.value === OptionFlagMultiUpdateParamActionType.ADD) {
        dataSource = props.flags;
    } else if (props.value === OptionFlagMultiUpdateParamActionType.REMOVE) {
        const checkFlag = getFlatArray(props.validItems);
        dataSource = props.updatedFlag as any;
        if (checkFlag.length === 0) {
            return (
                <p>
                    {' ' + props.t("ERRORS:NO_FLAGS_FOUND_TO_REMOVE")}
                </p>
            );
        }

    }
    const selectedFlags = dataSource && props.updatedFlag ? selectFlags(dataSource, props.updatedFlag) : [];

    return (
        <>
            <SelectField
                placeholder={props.t("PSL_WF_S_MULTI:SELECT_ACTION")}
                value={props.value}
                dataSource={[OptionFlagMultiUpdateParamActionType.ADD, OptionFlagMultiUpdateParamActionType.REMOVE]}
                rendererKey={(value: OptionFlagMultiUpdateParamActionType) => renderActionTypeLabel(value, props.t)}
                onChange={props.onChange}
            />
            {props.value &&
                <div style={{ marginTop: '20px', }}>
                    <SelectField
                        placeholder={props.t("PSL_FLAG_MULTI:ADD_ACTION")}
                        value={selectedFlags}
                        multi={true}
                        dataSource={dataSource}
                        rendererKey={(value: FlagDto) => renderFlagLabel(value, props.t)}
                        onChange={props.OnAddDeleteChange}
                        clearable={false}
                    />
                </div>
            }
            {props.value === OptionFlagMultiUpdateParamActionType.REMOVE && <div style={{ marginTop: '20px', }}>
                <span style={{ fontWeight: 'bold', fontSize: 14 }}>{props.t('PSL_FLAG_MULTI:HINT_TEXT')}</span>
            </div>}
            <div style={{ marginTop: '20px', textAlign: 'right' }}>
                <Button
                    icon={'arrow right'}
                    disabled={props.disableNext}
                    onClick={props.nextAction}
                />
            </div>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/views/OptionsView/MultipleFlagUpdate/FlagActionSelection.tsx